import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ActiveInactiveItinerary,
  bulkUploadItineraries,
  createItinerary,
  deleteItinerary,
  getAllActiveItinerary,
  getAllItinerary,
  getItineraryByID,
  updateItinerary,
} from "./services/itineary.services";
import { IItineary, IItinearyInitialState } from "./itinearyModel";

const initialState: IItinearyInitialState = {
  loading: false,
  formLoading: false,
  bulkUploadLoading: false,
  error: "",
  ItinearyList: [],
  ItineraryID: null,
  ItinearyDetail: {
    CityID: null,
    ItineraryTitle: "",
    Description: "",
    ItineraryImage: "",
    IsActive: 1,
  },
};

const itinearySlice = createSlice({
  name: "itineary",
  initialState,
  reducers: {
    clearItinearyDetails: (state) => {
      state.ItinearyDetail = initialState.ItinearyDetail;
    },
    setItinearyID: (state, action) => {
      state.ItineraryID = action.payload;
    },
    clearItinearyID: (state) => {
      state.ItineraryID = initialState.ItineraryID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllItinerary.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllItinerary.fulfilled,
      (state, action: PayloadAction<IItineary[]>) => {
        state.loading = false;
        state.ItinearyList = action.payload || [];
      }
    );
    builder.addCase(getAllItinerary.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ItinearyList = [];
    });
    builder.addCase(createItinerary.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createItinerary.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createItinerary.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateItinerary.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateItinerary.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateItinerary.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteItinerary.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteItinerary.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteItinerary.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getItineraryByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getItineraryByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.ItinearyDetail = action.payload;
    });
    builder.addCase(getItineraryByID.rejected, (state, action) => {
      state.formLoading = false;
      state.ItinearyDetail = initialState.ItinearyDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveItinerary.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveItinerary.fulfilled,
      (state, action: PayloadAction<IItineary[]>) => {
        state.loading = false;
        state.ItinearyList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveItinerary.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ItinearyList = [];
    });
    builder.addCase(ActiveInactiveItinerary.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveItinerary.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveItinerary.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
      builder.addCase(bulkUploadItineraries.pending, (state) => {
      state.bulkUploadLoading = true;
      state.error = "";
    });
    builder.addCase(bulkUploadItineraries.fulfilled, (state) => {
      state.bulkUploadLoading = false;
    });
    builder.addCase(bulkUploadItineraries.rejected, (state, action) => {
      state.bulkUploadLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearItinearyDetails, clearItinearyID, setItinearyID } =
  itinearySlice.actions;
export default itinearySlice.reducer;
